'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'socks';
var width = 512;
var height = 512;
var aliases = [129510];
var unicode = 'f696';
var svgPathData = ['M32 416c0 35.3 28.7 64 64 64l3.5 0c8.7 0 17.2-1.7 25.2-4.9-8.1-18-12.7-38.1-12.7-59.1 0-45.3 21.3-88 57.6-115.2l57.6-43.2c8.1-6 12.8-15.5 12.8-25.6l0-104-80 0 0 104c0 35.3-16.6 68.4-44.8 89.6L57.6 364.8C41.5 376.9 32 395.9 32 416zM160 48l0 48 80 0 0-48c0-5.5 .5-10.8 1.3-16L176 32c-8.8 0-16 7.2-16 16zm32 368c0 35.3 28.7 64 64 64l3.5 0c14.9 0 29.5-5 41.3-14.1l116.1-89.8C436.5 361 448 337.6 448 312.9l0-184.9-128 0 0 104c0 35.3-16.6 68.4-44.8 89.6l-57.6 43.2C201.5 376.9 192 395.9 192 416zM320 48l0 48 128 0 0-48c0-8.8-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16z', 'M124.7 475.1c-7.9 3.2-16.5 4.9-25.2 4.9L96 480c-35.3 0-64-28.7-64-64 0-20.1 9.5-39.1 25.6-51.2l57.6-43.2C143.4 300.4 160 267.3 160 232l0-104 80 0 0-32-80 0 0-48c0-8.8 7.2-16 16-16l65.3 0c1.9-11.5 5.9-22.3 11.5-32L176 0c-26.5 0-48 21.5-48 48l0 184c0 25.2-11.9 48.9-32 64L38.4 339.2C14.2 357.3 0 385.8 0 416 0 469 43 512 96 512l3.5 0c14.5 0 28.7-3.2 41.6-9.1-6.5-8.6-12-17.8-16.5-27.7zM336 0c-26.5 0-48 21.5-48 48l0 184c0 25.2-11.9 48.9-32 64l-57.6 43.2c-24.2 18.1-38.4 46.6-38.4 76.8 0 53 43 96 96 96l3.5 0c22 0 43.4-7.3 60.8-20.8l116.1-89.7c27.4-21.2 43.5-53.9 43.5-88.6L480 48c0-26.5-21.5-48-48-48L336 0zM320 48c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16l0 48-128 0 0-48zm0 80l128 0 0 184.9c0 24.8-11.5 48.2-31.1 63.3L300.8 465.9C289 475 274.4 480 259.5 480l-3.5 0c-35.3 0-64-28.7-64-64 0-20.1 9.5-39.1 25.6-51.2l57.6-43.2C303.4 300.4 320 267.3 320 232l0-104z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSocks = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;